import React, { useState } from 'react'
import { Media } from 'react-breakpoints'
import { Collapse, IconButton, Typography } from '@material-ui/core'
import { ExpandLess as ExpandLessIcon, ExpandMore as ExpandMoreIcon } from '@material-ui/icons'
import clsx from 'clsx'

import useStyles from './SectionBlock.style'

const SectionBlock = ({
  children,
  className,
  sectionClassName,
  title,
  body,
  hiddenBody = false,
  hiddenExpandedLink = false
}) => {
  const classes = useStyles()

  const [expanded, setExpanded] = useState(true)
  const [isTextRevealed, setIsTextRevealed] = useState(!hiddenBody || (body && body.length < 200))

  const renderMini = () => (
    <div className={clsx(classes.sectionContainer, sectionClassName)}>
      <div className={classes.header}>
        {title && (
          <Typography variant='h3' className={className}>
            {title}
          </Typography>
        )}

        {!hiddenExpandedLink && (
          <IconButton
            onClick={() => setExpanded((state) => !state)}
            style={{ flexShrink: 0 }}
            color='primary'
            size='small'
            className={classes.button}
            aria-label='show more'>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        )}
      </div>
      {body && (
        <div className={clsx(classes.readMoreBox, isTextRevealed && classes.readMoreBoxRevealed)}>
          <Typography variant='body1'>{body}</Typography>
          {!isTextRevealed && (
            <div className={classes.readMoreButtonContainer}>
              <button onClick={() => setIsTextRevealed(true)}>Ver descripción completa</button>
            </div>
          )}
        </div>
      )}
      <Collapse in={expanded} timeout='auto' unmountOnExit>
        {children}
      </Collapse>
    </div>
  )
  const render = () => (
    <div className={clsx(classes.sectionContainer, sectionClassName)}>
      {title && (
        <Typography className={className} variant='h3' title={title}>
          {title}
        </Typography>
      )}
      {body && (
        <div className={clsx(classes.readMoreBox, isTextRevealed && classes.readMoreBoxRevealed)}>
          <Typography variant='body1'>{body}</Typography>
          {!isTextRevealed && (
            <div className={classes.readMoreButtonContainer}>
              <button onClick={() => setIsTextRevealed(true)}>Ver descripción completa</button>
            </div>
          )}
        </div>
      )}
      {children}
    </div>
  )
  return (
    <Media>
      {({ breakpoints, currentBreakpoint }) =>
        breakpoints[currentBreakpoint] < breakpoints.md ? renderMini() : render()
      }
    </Media>
  )
}

export default SectionBlock
